<template>
  <v-dialog
    :value="show"
    persistent
    width="30%">
    <v-card>
      <v-card-text class="pt-4 pl-4 pr-4">
        <v-layout row wrap justify-center align-center>
          <v-flex md3 text-xs-center>
            <v-icon x-large class="error--text darken-1">
              fas fa-info-circle
            </v-icon>
          </v-flex>
          <v-flex md9>
            {{ message }}
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-2 pr-4 pl-4 pb-3">
        <v-spacer></v-spacer>
        <v-btn flat @click="$emit('close')">Cancelar</v-btn>
        <v-btn
          @click="$emit('accept')"
          class="k-orange-linear-text"
          flat>
            Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/global/ConfirmDialog.vue